import { Button } from '../../components/Button';
import { FavoriteButton } from './FavoriteButton';
import { PencilSquareIcon } from '@heroicons/react/24/outline';
import { ErrorBoundary } from '../../components/errorBoundary';

interface TripActionsProps {
  isOwner: boolean;
  tripId: string;
  linkSecret: string | null;
}

/**
 * Presentational component for trip action buttons.
 * Shows edit button for owner, favorite button for non-owners.
 */
export const TripActions = ({ isOwner, tripId, linkSecret }: TripActionsProps) => {
  return (
    <div className="relative -mt-6 mb-8 max-w-7xl mx-auto px-4 md:px-8">
      <div className="flex justify-center">
        {isOwner ? (
          <Button
            variant="primary"
            href={`/trips/${tripId}`}
            aria-label="Edit this trip"
            iconBefore={<PencilSquareIcon className="w-5 h-5" />}
          >
            Edit Trip
          </Button>
        ) : (
          <ErrorBoundary>
            <FavoriteButton tripId={tripId} linkSecret={linkSecret} />
          </ErrorBoundary>
        )}
      </div>
    </div>
  );
};
